import moment from 'moment';

export const isTokenExpired = (expiresAt: string): boolean => {
  const currentDate = moment();
  const expiresAtDate = moment(expiresAt);

  return expiresAtDate.unix() < currentDate.unix();
};
